import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { IoChevronBackCircleOutline } from "react-icons/io5";
import instance from "../../api/api";
// import Input from "../../features/Input";
// import Button from "../../features/Button";
// import Swal from "sweetalert2";
// import withReactContent from "sweetalert2-react-content";
// import Spinner from "react-bootstrap/Spinner";
// import Table from "react-bootstrap/Table";
// import { Tabs } from "antd-mobile";
// import {Help} from "../../utils"

function DetailCity() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [detailVille, setDetailVille] = useState(null);
  const [isLoading,setIsLoading] = useState(true)

  useEffect(() => {
    const getDetailCity = async () => {
      console.log("lancer");
      try {
        const response = await instance.get(`cities/${id}`);
        console.log("Villes", response);
        const ville = response.data.data;
        setDetailVille(ville);
        setIsLoading(false)
      } catch (error) {
        console.error("Une erreur s'est produite : ", error);
        setIsLoading(false)
      }
    };
    getDetailCity();
  }, [id]);

  if(isLoading) return <h1 className="text-center pt-5">Chargement...</h1>

  return (
    <div className="detail-student">
      <div className="back-user">
        <IoChevronBackCircleOutline
          className="back-home"
          onClick={() => {
            navigate(-1);
          }}
        />
        {detailVille && (
          <h5>
            <span className="text-primary">{detailVille.name}</span> /{" "}
            <span className="text-primary">Détail</span>
          </h5>
        )}
      </div>
      {detailVille && (
        <div>
          <p>
            {" "}
            <span className="text-secondary fw-bold">Ville :</span>{" "}
            {detailVille.name}{" "}
          </p>

          <div>
            <span className="text-secondary fw-bold">Communes :</span>
            <ul>
              {detailVille?.municipalities.map((item) => (
                <li key={item.id} className="m-0 p-0">
                  {item.name}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
}

// function GetPersonnel(props) {
//   const {coupons} = props
//   const personnel = []

//   for(const item in coupons){
//     if((item === "assistant_comptable"
//     || item === "responsable_couponss"
//     || item === "supervisers") && coupons[item] !== null){
//       console.log(coupons[item])
//       personnel.push(coupons[item])
//     }
//     if(item === "supervisers" && coupons[item] !== null){
//       coupons[item].vendeurs.forEach(element => {
//         personnel.push(element)
//        });

//     }
//   }
//   console.log("personnel",personnel)
// //   if(personnel[0] === null) return(
// // <tbody className="text-center">
// //   <tr>
// //     <td colSpan={5}>Pas de donnée.</td>
// //     </tr>
// // </tbody>
// //   );

//     return(
//       <tbody className="text-center">
// {personnel.length > 0 ? (
//                     personnel.map((item) => (
//                       <tr key={item.id}>
//                         <td>{item.lastname}</td>
//                         <td>{item.firstname}</td>
//                         <td>{item.phone1}</td>
//                         <td>{item.email}</td>
//                         <td>{item.role ? item.role.label:null}</td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr className="w-100">
//                       <td colSpan="5" className="text-center">
//                         Pas de donnée.
//                       </td>
//                     </tr>
//                   )}
// </tbody>
//     )
// }

// function GetStock(props) {
//   const {coupons} = props
//   const stock = []
//   for(const item in coupons){
//     if(item === "responsable_couponss" && coupons[item] !== null){
//       coupons[item].requetes.forEach(element => {
//         if(element.livraison === "Livrer"){
//           stock.push(element)
//         }
//        });

//     }
//   }
//   console.log("stock",stock)

//     return(
//       <tbody className="text-center">

// {stock.length > 0 ? (
//                     stock.map((item) => (
//                       <tr key={item.id}>
//                         <td>{new Date(item.created_at).toLocaleDateString("fr")}</td>
//                         <td className="position-relative">
//                           {Help.calculeTotal(item.produits)}
//                           </td>
//                         <td className="position-relative">
//                           {
//                             item.produits.map(prod=>{
//                               return(
//                                 <span key={prod.id} className="position-absolute span-tableau">{prod.libelle}</span>
//                               )
//                             })
//                           }
//                           </td>

//                         <td className="position-relative">{
//                             item.produits.map(prod=>{
//                               return(
//                                 <span key={prod.id} className="position-absolute span-tableau">{prod.pivot.nombre}</span>
//                               )
//                             })
//                           }</td>
//                         <td className="position-relative">
//                           {
//                             item.produits.map(prod=>{
//                               return(
//                                 <span key={prod.id} className="position-absolute span-tableau">{prod.pivot.nombre_total}</span>
//                               )
//                             })
//                           }</td>

//                           <td className="position-relative">
//                           {
//                             item.produits.map(prod=>{
//                               return(
//                                 <span key={prod.id} className="position-absolute span-tableau">
//                                   {Number(prod.pivot.nombre)-Number(prod.pivot.nombre_total)}</span>
//                               )
//                             })
//                           }
//                           </td>

//                       </tr>
//                     ))

//                   ) : (
//                     <tr className="w-100">
//                       <td colSpan="6" className="text-center">
//                         Pas de donnée.
//                       </td>
//                     </tr>
//                   )}
// </tbody>
//     )
// }

export default DetailCity;
